const HAS_URL_SCHEME = /^[a-z][a-z0-9+.-]*:/i

/**
 * Values like `www.example.com` lack a URL scheme; the browser then resolves them as paths
 * relative to the current document (e.g. `/event/www.example.com`). Prefix `https://` when
 * no scheme is present so links open as external URLs.
 */
export function ensureAbsoluteWebUrl(url: string): string {
  const trimmed = url.trim()
  if (!trimmed) return trimmed
  if (HAS_URL_SCHEME.test(trimmed)) {
    return trimmed
  }
  if (trimmed.startsWith('//')) {
    return trimmed
  }
  return `https://${trimmed}`
}
